import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SHOPSCUSTOMMAPPAGE_LEGACY_FIELD_ORDER = [
  { type: 'separator' },
  "meta_description"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  shopsCustomMapPageDescriptor: _generatedShopsCustomMapPageDescriptor,
  shopsCustomMapPageBlocDefinition,
  shopsCustomMapPageDashboardLayout,
  shopsCustomMapPageConfig,
  shopsCustomMapPageResolveConfig,
  shopsCustomMapPageProperties,
} = doodBlockConfig(
  {
    name: "Shops custom map page",
    internal_name: "Shops custom map page",
    url: "custom-map",
    defaultParent: [/^Main Layout$/i],
    componentType: 'ShopsCustomMapPageComponent',
    category: 'page',
    description: "Shops custom map page.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
,
    slots: [
      {
        key: 'body',
        name: "pages.blocks.shops-custom-map-page.body.label",
        accept: 'explicitOnly',
        allowedTypes: [".*(?<!Page)"],
        slotItemFormat: 'ids',
      },
      {
        key: 'footer',
        name: "pages.blocks.shops-custom-map-page.footer.label",
        accept: 'explicitOnly',
        allowedTypes: ["BigFooterBlock", "LegalsFooterBlock", "HtmlBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    meta_description: propertyValue({
      type: 'textarea',
      value: '',
      options: {
        label: "pages.blocks.shops-custom-map-page.meta-description.label",
        help: "pages.blocks.shops-custom-map-page.meta-description.help",
        rows: 3,
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.shops-custom-map-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.shops-custom-map-page.fieldset.seo.label",
            fields: ["meta_description"],
          },
          {
            legend: "pages.blocks.shops-custom-map-page.fieldset.blocks.label",
            fields: ["body", "footer"],
          },
        ],
      },
    ],
  })
);

export function shopsCustomMapPageDescriptor(): IBlockDescriptor;
export function shopsCustomMapPageDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopsCustomMapPageDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopsCustomMapPageDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopsCustomMapPageDescriptor, shopsCustomMapPageProperties, fieldOrder);
}

export {
  shopsCustomMapPageBlocDefinition,
  shopsCustomMapPageDashboardLayout,
  shopsCustomMapPageProperties,
  shopsCustomMapPageConfig,
  shopsCustomMapPageResolveConfig,
};

export type ShopsCustomMapPageConfig = typeof shopsCustomMapPageConfig;
